<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="2">
                <strong>{{ $t('AccountCirculation') }}</strong>

              </CCol>

            </CRow>
          </CCardHeader>
          <CCardBody>
            <CRow class="m-1">

              <CCol col="3">

                <treeselect
                    v-model="selected_person"
                    :options="moein_list"
                    :async="sync_person"
                    :load-options="load_persons"
                    :cacheOptions='false'
                    :normalizer="normalizer_persons"
                    @select="select_user"
                    :placeholder="$t('search')"
                />
              </CCol>

              <CCol col="1">
                <CButton @click="get_lists" color="dark"
                         size="sm">
                  <CIcon size="sm" name="cil-zoom"/>
                </CButton>
              </CCol>
              <CCol col="3">
                <date-picker
                    :label="$t('components.startDate')"
                    v-model="start_date"></date-picker>
              </CCol>
              <CCol col="3">
                <date-picker
                    :label="$t('components.endDate')"
                    v-model="end_date"></date-picker>

              </CCol>

            </CRow>
            <CDataTableFixed
                :items="items"
                :fields="fields"
                :items-per-page="200"
                hover
                border
                :pagination="get_pagination"
                striped
            >
              <template #row_id="{item,index}">

                <td>
                  <p class="text-center">{{ index + 1 }}</p>

                </td>

              </template>

              <template #amount="{item}">
                <td :style="'text-align:right'">
                  <p style="text-align:right">{{ get_currency(item.amount) }}</p>
                </td>
              </template>
              <template #docDate="{item}">
                <td>
                  <p style="text-align: center">{{
                      get_date(item.docDate)
                    }}</p>
                </td>
              </template>
              <template #amountNegetive="{item}">
                <td :style="'text-align:right'">
                  <p style="text-align:right">{{ get_currency(item.amountNegetive) }}</p>
                </td>
              </template>
              <template #balanceBefore="{item}">
                <td :style="'text-align:right'">
                  <p style="text-align:right" v-if="item.balanceBefore!=null">
                    {{ get_currency(item.balanceBefore) }}</p>
                </td>
              </template>
              <!--              <template #accBalance="{item}">-->
              <!--                <td :style="get_style(item)+'text-align:right'">-->
              <!--                  <p v-if="item.amount>item.amountNegetive" style="text-align:right">{{ get_currency(item.accBalance) }}</p>-->
              <!--                  <p v-else style="text-align:right">{{ get_currency(item.accBalanceNegetive) }}</p>-->
              <!--                </td>-->
              <!--              </template>-->


              <template #accBalance="{item}">
                <td>
                  <p :style="'text-align:right; '+get_style_price(item,'accBalance')">{{
                      get_currency(item.accBalance)
                    }}</p>
                </td>
              </template>

              <template #masterId="{item}">
                <td style="text-align: center">
                  <a href="javascript:void(0)" class="text-primary"
                     v-on:click="goToDocuments(item)">
                    {{ item.masterCode }}
                  </a>

                </td>

              </template>
              <template #payDocCode="{item}">
                <td >
                  <a href="javascript:void(0)" class="text-primary"
                     v-on:click="goToAccountingDocPay(item)">
                    {{ item.payDocCode }}
                  </a>
                  -
                  <a href="javascript:void(0)" class="text-primary"
                     v-on:click="goToAccountingDoc(item)">
                    {{ item.accDocCode }}
                  </a>

                </td>

              </template>

              <template #summary="{item}">
                <td>
                  <p v-if="item.summary != 'null'">{{ item.summary }}</p>
                </td>
              </template>
              <template #statusName="{item}">
                <td>
                  <p>{{ item.statusName }} - {{ item.extraInfo }}</p>
                </td>
              </template>

              <template #caption>
                <tr class="total-table">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>{{ $t('totalCirculation') }}</td>
                  <td>{{ get_currency(calculate_items(items, 'amountNegetive')) }}</td>
                  <td>{{ get_currency(calculate_items(items, 'amount')) }}</td>
                  <td>{{
                      get_currency(Math.abs(calculate_items(items, 'amount') -
                          calculate_items(items, 'amountNegetive')))
                    }}
                  </td>
                </tr>
              </template>
            </CDataTableFixed>
          </CCardBody>
          <CCardFooter>

          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
    <CModal
        :show.sync="show_factor_detail"
        :no-close-on-backdrop="true"
        :centered="true"
        :title="$t('InventoryBill')"
        size="lg"
        color="dark"
    >
      <CCard id="printMe">
        <ShowPayReceiveDocs :doc_id="selected_doc_id"/>

      </CCard>


      <template #footer>

        <CButton
            @click="show_factor_detail = false"
            color="success"
        >{{ $t("buttons.close") }}
        </CButton>
      </template>
    </CModal>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../../main';
// import the styles
import ShowPayReceiveDocs from "@/views/panel/accounting/ShowPayReceiveDocs";
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
import moment from 'moment-jalaali'

var simulateAsync = null
const simulateAsyncOperation = fn => {
  if (simulateAsync != null) {
    clearTimeout(simulateAsync)
  }
  simulateAsync = setTimeout(fn, 1000)
}
var items = [];


export default {
  name: 'Login',
  components: {
    Treeselect,
    ShowPayReceiveDocs
  },
  data() {
    return {
      show_factor_detail: false,
      selected_doc_id: null,
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      selected_tafsili_type: 2,
      //tasiliType 0 =>Other, 1=> Personal, 2=> Customers, 3=> Sellers, 4=> Persons, 5=> Bank,, 6=> CashBox,

      // tafsili_types: [
      //   {label: this.$t('Other'), value: 0},
      //   {label: this.$t('Customers'), value: 2},
      //   {label: this.$t('Suppliers'), value: 3},
      //   {label: this.$t('BankPost'), value: 5},
      //   {label: this.$t('cash'), value: 6},
      //   {label: this.$t('sidebars.personal'), value: 1},
      //
      // ],
      validate_errors: [],
      selected_level: '',
      start_date: '',
      end_date: '',

      items: items.map((item, row_id) => {
        return {...item, row_id}
      }),
      fields: [
        {key: 'row_id', label: this.$t('tables.row'), sorter: false, _style: 'width:3%'},
        {key: 'docDate', label: this.$t('date'), _style: 'width:10%'},
        {key: 'statusName', label: this.$t('documentType'), _style: 'width:15%'},
        {key: 'masterId', label: this.$t('reference'), _style: 'width:7%'},
        {key: 'payDocCode', label: this.$t('docNumber'), _style: 'width:7%'},
        {key: 'summary', label: this.$t('tables.summary'), _style: 'width:10%'},

        {key: 'amountNegetive', label: this.$t('tables.debtor'), _style: 'width:10%'},
        {key: 'amount', label: this.$t('tables.creditor'), _style: 'width:10%'},
        {key: 'accBalance', label: this.$t('tables.balance'), _style: 'width:10%'},
      ],

      status_form: 0,

      selected_person_name: '',
      selected_person: null,
      person_async_list: [],
      sync_person: true,
      person_name: '',
      accounting_list: [],
      moein_list: [],

      normalizer_persons(node) {
        return {
          id: node.userId,
          label: node.personCode + " " + node.userName + " " + node.surName,
        }
      },

    }
  },
  created() {
  },
  mounted() {

    this.$root.root_validate_errors = [];
    this.start_date = this.get_day_before_today_in_day(7);
    this.end_date = this.get_today();
    bus.$on("change_tajmi_all_to_one", (data) => {

      this.sync_person = false;
      this.moein_list = [{
        personCode: data.personCode, userId: data.personId,
        userName: '',
        surName: ''
      }]
      setTimeout(() => {
        this.selected_person = data.personId;
        this.selected_person_name = data.personCode + " " + data.personName;
        this.get_lists();
      }, 300);
      setTimeout(() => {
        this.sync_person = true;
      }, 1000);
    });
    // this.get_lists();
    this.get_lists_groups();
  },
  watch: {
    'selected_tafsili_type': function () {

      this.selected_person = null
    }
  },
  methods: {

    load_persons({action, searchQuery, callback}) {
      var self = this;
      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {
          let options;
          const formData = new FormData();

          formData.append('SearchTxt', searchQuery);
          var url = "GetUsers";

          // formData.append('Id', 0);
          // formData.append('TypeId', self.selected_tafsili_type);
          // formData.append('IsActive', 0);

          axios.post(url, formData, {show_pros: true}).then(function (response) {
            options = response.data.data;

            callback(null, options);

          })
              .catch(function (error) {

                console.log(error);
              });

        })
      }
    },
    get_style(item) {
      var color = '#56ff42';
      if (item.personAccountId == 0) {
        // return 'backgroundColor: \'#56ff42\'';
        return {
          backgroundColor: color
        }
      }
    },
    get_style_price(item, index) {
      var color = '#ff1403';
      // if(item.natureId==1){
      if (parseFloat(item[index]) < 0) {
        return 'color:#ff1403;'
      }


    },
    select_user(node, instance) {
      this.selected_person_name = node.fullName + " " + node.personCode;

    },
    get_lists() {
      var self = this;

      const formData = new FormData();


      formData.append('PartyId', this.selected_person);
      formData.append('FromDate', this.start_date);
      formData.append('ToDate', this.end_date);

      axios.post('GetPartyAccountsRpt', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
          self.items.forEach(function (val, index) {
            if (index == 0) {
              val.accBalance = val.amount

              if (val.amount > 0) {
                val.amountNegetive = Math.abs(val.amount);
                val.amount = 0;

              } else {
                val.amount = Math.abs(val.amount);
                val.amountNegetive = 0;
              }
            } else {
              val.reminingBefore = self.items[index - 1].accBalance;

              val.accBalance = parseFloat(val.reminingBefore) + parseFloat(val.amount);
              // val.accBalanceFinal =val.accBalance
              if (val.amount > 0) {
                val.amountNegetive = Math.abs(val.amount);
                val.amount = 0;

              } else {
                val.amount = Math.abs(val.amount);
                val.amountNegetive = 0;
              }

            }

          })
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_lists_groups() {

      var self = this;
      self.items_parent = [];
      self.data_with_children = []

      const formData = new FormData();
      var url = "Get_AllAccountingGroups";

      axios.post(url, formData, {}).then(function (response) {

            var content_data = response.data;

            if (content_data.statusCode == 0) {

              self.accounting_list = response.data.data
              self.accounting_list.forEach((val) => {
                if (val.parentId == 0) {

                  self.get_childrens_one_sub(val.id, self.accounting_list).forEach((val2) => {

                    self.get_childrens_one_sub(val2.id, self.accounting_list).forEach((val3) => {

                      self.moein_list.push(val3)

                    });

                  });

                }

              });
            } else {
              self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

            }

          }
      )
          .catch(function (error) {
            console.log(error);
          });

    },
    get_childrens_one_sub(parent_id, list) {
      var array = [];
      var self = this;
      list.forEach((val2) => {

        if (parent_id == val2.parentId) {
          // var obj = {label: val2.accountCode + " " + val2.accountName, value: val2.id, code: val2.accountCode}
          array.push(val2);


        }
      });
      return array;
    },
    goToDocuments(item) {
      window.open('/dashboard/documents/show/' + item.masterId)
      // this.$router.push({path: '/dashboard/documents/show/' + item.masterId});

    },
    goToAccountingDocPay(item) {
      this.show_factor_detail = true
      this.selected_doc_id = item.payDocId
    },
    goToAccountingDoc(item) {
      window.open('/dashboard/accounting/show-accounting-doc/'+item.accDocId)
    },
  }
}

</script>
